import {
    GET_LIST_UNIT,
    UPDATE_SPECIFIC_UNIT,
    CREATE_NEW_UNIT,
    REMOVE_UNIT,
    GET_UNIT_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    unitList: [],
    unitActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_UNIT: {
            return {
                ...state,
                unitList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_UNIT_ACTIVE: {
            return {
                ...state,
                unitActiveList: action.payload.data,
            }
        }
        case CREATE_NEW_UNIT: {
            return {
                ...state,
                unitList: [action.payload, ...state.unitList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_UNIT: {
            let index = state.unitList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.unitList];
            temp[index] = action.payload;
            return { ...state, unitList: temp }
        }
        case REMOVE_UNIT: {
            let temp = state.unitList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, unitList: temp }
        }
        default: return { ...state };
    }
}
